// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-glass-detail-related----styles-module---container---2wYSp"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/glass-detail/related/styles.module.css
// module id = 648
// module chunks = 99110987824835